import useLocalState from '../../../../hooks/useLocalState';
import useLoadLines from './functions/useLoadLines';
import useSearches from './functions/useSearches';
import useDeleteLine from './functions/useDeleteLine';

export default function useLines() {
  const [, setLineMapBeingShow] = useLocalState('lineMapBeingShow');
  const [, setLineBeingPostedShape] = useLocalState('lineBeingPostedShape');

  const {
    lines,
    isLoading,
    apiFetched,
    directionsTagLiterals,
    handleTryAgain,
    userProfile,
    companyCode,
    loadLines,
  } = useLoadLines();

  const {
    filteredLines,
    handleChangeSearchTerm,
    searchTerm,
  } = useSearches({ lines });

  const {
    isDeleting,
    modalDeleteShow,
    setModalDeleteShow,
    lineBeingDeleted,
    setLineBeingDeleted,
    directionTagLiterals,
    deleteLine,
  } = useDeleteLine({ loadLines });

  return {
    userProfile,
    isLoading,
    companyCode,
    lines,
    apiFetched,
    searchTerm,
    handleChangeSearchTerm,
    filteredLines,
    directionsTagLiterals,
    setLineMapBeingShow,
    setLineBeingPostedShape,
    handleTryAgain,
    isDeleting,
    modalDeleteShow,
    setModalDeleteShow,
    lineBeingDeleted,
    setLineBeingDeleted,
    directionTagLiterals,
    deleteLine,
  };
}
